"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function ResourceschedulesMultitoneOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 8.667,
    cy: 8,
    r: 4,
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M10.296 8.873v5.53a.395.395 0 01-.395.396h-6.32a.395.395 0 01-.396-.395V3.358a.395.395 0 01.395-.395H6.1a4.65 4.65 0 01.487-1.185H3.58A1.58 1.58 0 002 3.358V14.42A1.58 1.58 0 003.58 16h6.321a1.58 1.58 0 001.58-1.58V8.822a4.742 4.742 0 01-1.185.051z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M6.018 4.938c.032.2.078.399.138.593H5.16a.593.593 0 010-1.185h.79c.007.199.03.397.068.592zM6.843 6.914c.152.211.32.41.506.592H5.16a.593.593 0 110-1.185h1.32c.106.206.228.404.363.593zM6.74 13.432a1.383 1.383 0 110-2.766 1.383 1.383 0 010 2.766zm0-1.58a.198.198 0 10.001.395.198.198 0 000-.395zM10.691 0a4.156 4.156 0 00-4.148 4.148v.198c.012.198.035.396.071.592.042.201.097.4.166.593.103.277.236.541.395.79.13.21.278.408.443.593.193.22.409.418.644.592.596.44 1.298.712 2.034.79h.395a4.148 4.148 0 100-8.296zm.79 7a2.765 2.765 0 01-.79.111 2.947 2.947 0 01-2.615-1.58 2.58 2.58 0 01-.237-.593 2.445 2.445 0 01-.099-.79 2.955 2.955 0 011.185-2.37 2.908 2.908 0 011.766-.593 2.963 2.963 0 01.79 5.816z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M12.667 4.74H10.69a.593.593 0 01-.592-.592V2.193a.593.593 0 111.185 0v1.363h1.383a.593.593 0 010 1.185zM8.914 8.889a.593.593 0 01-.593.592h-3.16a.593.593 0 110-1.185h3.25a.604.604 0 01.458.36c.03.073.046.153.045.233z"
  }));
}

ResourceschedulesMultitoneOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
ResourceschedulesMultitoneOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = ResourceschedulesMultitoneOutline;
exports["default"] = _default;